import { Component, PropTypes } from 'react';
import Table from 'scripts/components/Table';
import Loading from 'scripts/components/Loading';
import NoContent from 'scripts/components/NoContent';
import { dataRefreshTime, apiBaseUrl, hubPageUrl } from 'scripts/config';
import { isValidCountry, getCookie, mapCountryCode } from 'scripts/utils';
import $ from 'jquery';
import cx from 'classnames';
import _ from 'lodash';
import styles from 'styles/content';

export default class Highlights extends Component {
	static propTypes = {
		display: PropTypes.string
	}

	constructor(props) {
		super(props);

		this.state = {};
	}

	componentWillMount() {
		this._geoCountry = mapCountryCode(getCookie('countryCode'));
	}

	componentDidMount() {
		this.getData();

		if (dataRefreshTime) {
			this.interval = setInterval(this.getData.bind(this), dataRefreshTime);
		}
	}

	componentWillUnmount() {
		this.interval = clearInterval(this.interval);
	}

	getData() {
		const dataUrl = `${__DEV__ ? 'scripts/mocks' : apiBaseUrl}/highlights.json`;
		this.request = $.getJSON(dataUrl);

		if (this._geoCountry && (!this.display || this.display === 'topMedals')) {
			const countryMedalsDataUrl = `${__DEV__ ? 'scripts/mocks/medals' : `${apiBaseUrl}/results/country`}.json`;
			this.requestCountryMedals = $.getJSON(countryMedalsDataUrl);
		}

		this.batchRequest = $.when(...[this.request, this.requestCountryMedals]).done(([highlights], requestCountryMedals) => {
			if (requestCountryMedals) {
				const [{ countries: countryMedals }] = requestCountryMedals;
				const validCountryMedals = countryMedals.filter(({ country }) => isValidCountry(country));
				const userCountryMedals = {..._.find(validCountryMedals, {country: this._geoCountry})};

				// Only inject user country into list if it's not already in the result set
				if (userCountryMedals && !_.find(highlights.topMedals, {country: userCountryMedals.country})) {
					userCountryMedals.position = _.findIndex(validCountryMedals, {country: this._geoCountry}) + 1;

					highlights.topMedals.splice(highlights.topMedals.length - 1, 1, {
						...userCountryMedals,
						isHighlight: true
					});
				}
			}

			this.setState(highlights);
		});
	}

	isLoaded() {
		return this.batchRequest
			&& this.batchRequest.state() === 'resolved';
	}

	isCompactHighlight() {
		return !!this.props.display;
	}

	renderHighlight(display, additionalProps) {
		const props = {
			type: 'item',
			content: this.state[display],
			...additionalProps
		};

		switch (display) {
			case 'nextEvent':
				props.title = 'Next scheduled event';
				break;

			case 'latestResult':
				props.title = 'Latest medalled result';
				break;

			case 'topMedals':
				props.type = 'list';
				props.title = 'Country medal ranking';
				break;
		}

		// When no content data show whitespace within widget
		if (!props.content || (display === 'latestResult' && !props.content.results)) {
			// But if compact version show message
			return (this.isCompactHighlight() &&
				<NoContent message={`Nothing to display for ${props.title.toLowerCase()}`} />);
		}

		return (
			<Table key={props.title} {...props}>
				{!!props.content.results
					&& <Table type="list" content={props.content.results} />}
			</Table>
		);
	}

	renderSingleHighlight() {
		return this.renderHighlight(this.props.display, {
			onHeaderClick: () => window.location.href = hubPageUrl,
			tracking: 'compact'
		});
	}

	renderAllHighlights() {
		return [
			this.renderHighlight('nextEvent'),
			this.renderHighlight('latestResult'),
			this.renderHighlight('topMedals', {
				onHeaderClick: () => this.props.handleTabChange(2)
			})
		];
	}

	render() {
		return (
			<div className={cx(styles.panel, {[styles.isCompact]: this.isCompactHighlight()})}>
				<div className={styles.panelTop}>
					<div className={styles.title}>Highlights</div>
				</div>

				{this.isLoaded()
					? this.isCompactHighlight()
						? this.renderSingleHighlight()
						: this.renderAllHighlights()
					: <Loading />}
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./scripts/components/Highlights.es6
 **/